/*========== MULTIPLE DASHBOARDS ACTIONS ============= */

export const listDashboards = () => ({
  type: 'LIST_DASHBOARDS',
});

export const createDashboard = (payload) => ({
  type: 'CREATE_DASHBOARD',
  payload,
});

export const selectDashboard = (payload) => ({
  type: 'SELECT_DASHBOARD',
  payload,
});

export const updateDashboardDetails = (payload) => ({
  type: 'UPDATE_DASHBOARD_DETAILS',
  payload,
});

export const deleteDashboard = (payload) => ({
  type: 'DELETE_DASHBOARD',
  payload,
});

export const setDefaultDashboard = (payload) => ({
  type: 'SET_DEFAULT_DASHBOARD',
  payload,
});

/*========== DASHBOARD TEMPLATES ACTIONS ============= */

export const getTemplates = (payload) => ({
  type: 'GET_TEMPLATES',
  payload,
});

export const createFromTemplate = (payload) => ({
  type: 'CREATE_DASHBOARD_FROM_TEMPLATE',
  payload,
});

/*========== DASHBOARD CONFIG ACTIONS ============= */

export const getDashboardConfig = () => ({
  type: 'GET_DASHBOARD_CONFIG',
});

export const setDashboardConfig = (payload) => ({
  type: 'SET_DASHBOARD_CONFIG',
  payload,
});

export const saveDashboardConfig = (payload) => ({
  type: 'SAVE_DASHBOARD_CONFIG',
  payload,
});

/*========== WIDGET ACTIONS ============= */

export const addWidget = (payload) => ({
  type: 'ADD_WIDGET',
  payload,
});

export const updateWidget = (payload) => ({
  type: 'UPDATE_WIDGET',
  payload,
});

export const deleteWidget = (payload) => ({
  type: 'DELETE_WIDGET',
  payload,
});

export const reorderWidgets = (payload) => ({
  type: 'REORDER_WIDGETS',
  payload,
});

/*========== WIDGET DATA ACTIONS ============= */

export const getWidgetData = (payload) => ({
  type: 'GET_WIDGET_DATA',
  payload,
});

export const setWidgetData = (payload) => ({
  type: 'SET_WIDGET_DATA',
  payload,
});

export const getBatchWidgetData = (payload) => ({
  type: 'GET_BATCH_WIDGET_DATA',
  payload,
});

export const setBatchWidgetData = (payload) => ({
  type: 'SET_BATCH_WIDGET_DATA',
  payload,
});

/*========== FILTER ACTIONS ============= */

export const setDateRangeFilter = (payload) => ({
  type: 'SET_DATE_RANGE_FILTER',
  payload,
});

export const setGlobalFilters = (payload) => ({
  type: 'SET_GLOBAL_FILTERS',
  payload,
});

export const resetFilters = () => ({
  type: 'RESET_FILTERS',
});

/*========== UI STATE ACTIONS ============= */

export const setEditMode = (payload) => ({
  type: 'SET_EDIT_MODE',
  payload,
});

export const setExpandedWidget = (payload) => ({
  type: 'SET_EXPANDED_WIDGET',
  payload,
});

export const setActiveModal = (payload) => ({
  type: 'SET_ACTIVE_MODAL',
  payload,
});

export const setSelectedWidget = (payload) => ({
  type: 'SET_SELECTED_WIDGET',
  payload,
});
